import { mapGetters } from 'vuex'
import moment from 'moment'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import EditCustomerSchool from './EditCustomerSchool'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import SahapanAddManual from './SahapanAddManual'
import api from '@/api'

export default {
    props: {
        value: {
            default: undefined,
        },
        getuseronly: {

            default: false,
        }
    },
    data: function () {
        return {
            sahapandialog: true,
            loading: true,
            user: {},
            isEditTag: false,
            usertag: '',
            profile_pic: '',
            saveloading: false,
            toauser: {
                paysolutionmerchantid: '',
                fillgood_token: '',
                shop_id: '',
            },
        }
    },
    components: {
        CustomerItemValue,
        EditCustomerValue,
        EditCustomerSchool,
        specialtext,
        SahapanAddManual,
        Tags,
    },
    computed: {
        ...mapGetters({
            selectedBot: 'selectedBot',
            isCoachlab: 'isCoachlab',
        }),
        isBU() {
            return this.$store.state.pageBU.includes(this.selectedBot.pageid)
        },
        filterIntent: function () {
            var vm = this
            if (vm.user && vm.user.intentlist) {

                return vm.user.intentlist.sort(function (a, b) {
                    if (parseInt(a[1]) > parseInt(b[1])) {
                        return -1
                    }

                    if (parseInt(a[1]) < parseInt(b[1])) {
                        return 1
                    }

                    return 0
                })
            } else {
                return []
            }
        },
        userLocale: function () {
            var vm = this
            return config.locale.find(function (locale) {
                if (vm.user.locale == locale.value) {
                    return locale.title
                }
            })
        },
        tags: function () {
            var vm = this
            if (vm.user.tags !== '' && vm.user.tags != null) {
                var usertags = vm.user.tags.split(',')
                return usertags
            } else {
                return []
            }
        },
        usertags: {
            get() {
                let vm = this
                if (vm.user && vm.user.tags && vm.user.tags !== '') {
                    var usertags = []

                    usertags = vm.user.tags.split(',')
                    var result = []
                    if (usertags) {
                        usertags.map(function (tag, index) {
                            result.push({ text: tag })
                        })
                    }
                    return result
                } else {
                    return []
                }
            },
            set(value) {
                let vm = this
                var result = []
                if (value) {
                    value.map(function (tag, index) {
                        result.push(tag.text)
                    })
                }
                vm.user.tags = result.join(',')
            },
        },
    },
    mounted: function () {
        this.getuserDetail()
        // this.user = this.value
        // this.cached_tag = this.user.tags
    },
    methods: {
        editTag() {
            this.isEditTag = true
            this.cached_tag = JSON.parse(JSON.stringify(this.user.tags))
        },
        saveSahapanUserProfile(type, payload) {
            var vm = this
            this.$set(this.user, type, payload.customer_value)
            vm.$store.dispatch('loading')
            var data = {
                lineid: this.user.id,
                firstname: this.user.realfirstname,
                lastname: this.user.reallastname,
                gender: this.user.gender,
                address: this.user.address,
                dob: this.user.dob ? moment(this.user.dob).format() : moment().format(),
                phoneno: this.user.phoneno,
                email: this.user.email,
            }
            api.saveSahapanUserProfile(data, function (error, response) {
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
                payload.onEdit()
                vm.$forceUpdate()
            })
        },
        getuserDetail() {
            let vm = this
            let data = { pageid: vm.selectedBot.pageid, userid: vm.value }
            api.getuserCustomer(data, function (error, response) {
                if (error) console.error(error)
                vm.user = response.data[0]
                var realname = response.data[0].realname ? response.data[0].realname.split(' ') : ''
                vm.user.realfirstname = realname.length > 0 ? realname[0] : ''
                vm.user.reallastname = realname.length > 1 ? realname[1] : ''
                vm.user.dob = vm.user.dob
                    ? moment(vm.user.dob).format('YYYY-MM-DD')
                    : moment().format('YYYY-MM-DD')
                if (vm.selectedBot.theme == 'toa') {
                    Object.assign(vm.user, JSON.parse(vm.user.json_variable))
                }
                vm.loading = false
            })
        },
        onEditAddress(payload) {
            var vm = this
            vm.$store.dispatch('loading')
            var data = {
                pageid: payload.pageid,
                usersid: payload.usersid,
                address: payload.customer_value,
            }
            api.saveUserAddress(data, function (error, response) {
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
                payload.onEdit()
            })
        },
        onEditContext(payload) {
            var vm = this
            vm.$store.dispatch('loading')
            var data = {
                pageid: payload.pageid,
                usersid: payload.usersid,
                context: payload.customer_value,
            }
            api.saveUserContext(data, function (error, response) {
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
                payload.onEdit()
            })
        },
        saveEditTag: function () {
            var vm = this
            var data = {
                pageid: vm.selectedBot.pageid,
                usersid: vm.user.id,
                tags: vm.user.tags,
            }
            api.saveUserTags(data, function (error, response) {
                if (error) {
                    console.error(error)
                }
                vm.cached_tag = vm.user.tags
                vm.isEditTag = false
            })
        },
        cancelEditTag: function () {
            this.user.tags = this.cached_tag
            this.isEditTag = false
        },
        onFailLoad: function () {
            this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
        },
        getFormatDate: function (date, format) {
            return moment(date).format(format)
        },
        addUserTags: function (newTags) {
            this.usertags = newTags
        },
        checkUserTags(obj) {
            this.errorTag = []
            if (obj.tag.text.length > 20) {
                this.errorTag.push('overmaxlength')
                obj.error()
            } else if (obj.tag.isDuplicate) {
                this.errorTag.push('duplicate')
                obj.error()
            } else obj.addTag()
        },
        onEditStatus: function (payload) {
            var vm = this
            vm.$store.dispatch('loading')
            var data = {
                pageid: payload.pageid,
                usersid: payload.usersid,
                status: payload.customer_value,
            }
            api.saveUserStatus(data, function (error, response) {
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
                payload.onEdit()
            })
        },
        onEditLineId: function (payload) {
            var vm = this
            vm.$store.dispatch('loading')
            var data = {
                pageid: payload.pageid,
                usersid: payload.usersid,
                lineid: payload.customer_value,
            }
            api.saveUserLineId(data, function (error, response) {
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
                payload.onEdit()
            })
        },
        onEditSchool: function (payload) {
            var vm = this
            vm.$store.dispatch('loading')
            var data = {
                pageid: payload.pageid,
                usersid: payload.usersid,
                school: payload.customer_value,
            }
            api.saveUserSchool(data, function (error, response) {
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
                payload.onEdit()
            })
        },
        onEditProvince: function (payload) {
            var vm = this
            vm.$store.dispatch('loading')
            var data = {
                pageid: payload.pageid,
                usersid: payload.usersid,
                province: payload.customer_value,
            }
            api.saveUserProvince(data, function (error, response) {
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
                payload.onEdit()
            })
        },
        onEditEmail: function (payload) {
            var vm = this
            vm.$store.dispatch('loading')
            var data = {
                pageid: payload.pageid,
                usersid: payload.usersid,
                email: payload.customer_value,
            }
            api.saveUserEmail(data, function (error, response) {
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
                payload.onEdit()
            })
        },
        onEditPhone: function (payload) {
            var vm = this
            vm.$store.dispatch('loading')
            var data = {
                pageid: payload.pageid,
                usersid: payload.usersid,
                phoneno: payload.customer_value,
            }
            api.saveUserPhoneno(data, function (error, response) {
                if (error) {
                    console.error(error)
                    vm.$store.dispatch('loading')
                }
                vm.$store.dispatch('loading')
                payload.onEdit()
            })
        },
    },
    watch: {
        // value: function() {
        //   this.user = this.value
        // }
    },
}


// WEBPACK FOOTER //
// ./src/components/view/dashboard/CustomerDetail.js